import { baseTheme } from "@acto/web-common/theme";
import type { ComparisonLegendRow } from "./ComparisonLegend";
import { InlineKpiFigure } from "./InlineKpiFigure";
import { KpiCardShell, type KpiCardTrend } from "./KpiCardShell";
import type { KpiFigureContent } from "./KpiFigure";

export interface KpiSingleView {
  figure: KpiFigureContent;
  legend: ComparisonLegendRow[];
}

export type KpiSingleTrend = KpiCardTrend<KpiSingleView>;

export interface KpiSingleCardProps {
  subtitle: string;
  title: string;
  trend: KpiSingleTrend;
}

export function KpiSingleCard({ subtitle, title, trend }: KpiSingleCardProps) {
  return (
    <KpiCardShell
      subtitle={subtitle}
      title={title}
      trend={trend}
      renderFigures={({ figure }) => (
        <InlineKpiFigure {...figure} seriesColor={baseTheme.fieldSalesTwo.colors.charts.primary} />
      )}
    />
  );
}
